<template>
  <v-reports
  v-if="access.report_discount"
    v-model="page"
    v-bind:headers="headers"
    v-bind:update="update"
    v-bind:data="data"
    v-bind:numPages="numPages"
    :data_loading="data_loading"
    @change-pagination="changePagination"
  ></v-reports>
  <error404 v-else></error404>
</template>
<script>
import Currency from "../../mixins/settings/currency";
export default {
  name: "ReportsDiscounts",
  mixins: [Currency],
  data: () => ({
    headers: [
      { text: "Name", value: "name", available: true, disabled: true },
      { text: "Discounts applied	", value: "applied", available: true },
      { text: "Amount discounted", value: "amount", available: true },
    ],
    data: [],
    params: {},
    page: 1,
    numPages: 1,
    data_loading: false,
    current_currency: 1,
    access:null
  }),
  methods: {
    changePagination(page) {
      this.page = page;
      this.update(this.params);
    },
    async update(params) {
      const current_currency = this.current_currency;
      this.data_loading = true;
      var start_date = new Date(params.start_date).getTime();
      var end_date = new Date(params.end_date).getTime();
      var discounts = this.$communicator.then(
        this,
        await this.$communicator("by_discount", {
          arguments: [start_date, end_date, 10, this.page],
          params: {
            custom: params.custom,
            start: params.start.time,
            end: params.end.time,
            services: params.service != "" ? [params.service] : [],
            employees: params.employee._id != "" ? [params.employee._id] : [],
          },
        })
      );
      for (let i = 0; i < discounts.data.length; i++) {
        discounts.data[i].amount = (
          Math.round(discounts.data[i].amount * current_currency) /
          current_currency
        ).toLocaleString();
      }
      this.data = discounts.data;
      this.data_loading = false;
      this.numPages = discounts.page;
    },
  },
  mounted() {
    this.get_currency();
    this.current_currency = this.currentCurrency == "usd" ? 100 : 1;
    this.headers = [
      { text: this.$t(`name`), value: "name", available: true, disabled: true },
      { text: this.$t(`discount_applied`), value: "applied", available: true },
      { text: this.$t(`amount_applied`), value: "amount", available: true },
    ];
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>
